<div class="p-2 text-black d-flex justify-content-between align-items-center box">
  <!--  <div >{{pageSize}} / {{length}}</div>-->
  <div>{{ currentPage }} {{ 'page' | translate }}</div>
  <div class="d-flex justify-content-center align-items-center arrow">
    <app-button btnType="icon" [disabled]="disabledBeforeBtn()" (onChangeClick)="toFirstPage()"
      ><app-icon>first_page</app-icon></app-button
    >
    <app-button btnType="icon" [disabled]="disabledBeforeBtn()" (onChangeClick)="toPrevPage()"
      ><app-icon>navigate_before</app-icon></app-button
    >
    <ng-container *ngTemplateOutlet="dropdown"></ng-container>
    <app-button btnType="icon" [disabled]="disabledAfterBtn()" (onChangeClick)="toNextPage()"
      ><app-icon>navigate_next</app-icon></app-button
    >
    <app-button btnType="icon" [disabled]="disabledAfterBtn()" (onChangeClick)="toLastPage()"
      ><app-icon>last_page</app-icon></app-button
    >
  </div>
  <ng-container *ngTemplateOutlet="dropdown2"></ng-container>
  @if (hidePageSize) {
    <div></div>
  }
</div>

<ng-template #dropdown>
  <ng-select
    [(ngModel)]="currentPage"
    [items]="pageNumbers"
    [clearable]="false"
    [searchable]="searchable"
    [dropdownPosition]="dropdownPosition"
    style="width: 60px"
    (change)="currentPageChange()"
  >
    <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
      {{ item }}
    </ng-template>
  </ng-select>
</ng-template>

<ng-template #dropdown2>
  @if (!hidePageSize) {
    <ng-select
      [(ngModel)]="pageSize"
      [items]="takes"
      [clearable]="false"
      [searchable]="false"
      [dropdownPosition]="dropdownPosition"
      style="width: 75px"
      (change)="currentTakeChange()"
    >
      <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
        {{ item }}
      </ng-template>
    </ng-select>
  }
</ng-template>
